// extracted by mini-css-extract-plugin
export default {"won":"styles_won__1yY6X","lost":"styles_lost__wxhGj","capitalise":"styles_capitalise__2Y8nC","highlight":"styles_highlight__W9oIL","offerId":"styles_offerId__hzoeO"};